import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Redirect,
} from 'react-router-dom';

import {
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import MainLayout from '../../common/components/MainLayout';
import * as profileActions from '../actions';
import classes from '../../css/getCSS';
import EmailSVG from '../../assets/img/email.svg';


class CompleteProfile extends Component {
  componentDidMount() {
    if (this.props.user.state !== 1 || !this.props.user.is_complete) {
      this.props.getProfileStatus(
        this.props.token,
      );
    }
    document.title = 'Your profile status';
    window.scrollTo(0, 0);
  }

  render() {
    if (this.props.user.state === 1 && this.props.user.is_complete) {
      return <Redirect to="/" />;
    }

    let display = (
      <div align="center">
        <br /><br /><br />
        <CircularProgress align="center" size={50} />
        <br />
        <Typography variant="subheading">Please wait. This may take some time! <br /> Please do not refresh the page.</Typography>
      </div>
    );

    if (this.props.profile_id) {
      const siteSettings = (<li className={classes.settingsText} dangerouslySetInnerHTML={{ __html: this.props.site_settings.registration_success_text }} />);  // eslint-disable-line
      display = (
        <React.Fragment>
          <Grid container spacing={8}>
            <Grid item md={6} xs={12} sm={6}>
              <Typography variant="body1">Profile Status</Typography>
              <Typography variant="headline" className={classes.colorDanger}>{this.props.profile_state}</Typography>
            </Grid>
            <Grid item md={6} xs={12} sm={6}>
              <Typography variant="body1">Profile ID</Typography>
              <Typography variant="headline">{this.props.profile_id}</Typography>
              <Typography variant="body2">You need to remember this</Typography>
            </Grid>
          </Grid>
          <br /><hr />
          <Typography align="center" variant="subheading">How to get your profile activated?</Typography>
          <ul className={classes.statusList}>
            {siteSettings}
            <li>You will get a confirmation Email once it is approved.</li>
            <li>You can then login to your account and search your life partner.</li>
          </ul>
        </React.Fragment>
      );
    }

    return (
      <MainLayout isAuthenticated onlyLogout>
        <Grid container justify="center">
          <Grid item md={8} sm={12} xs={12}>
            <br /><br />
            <Paper className={[classes.cardFancy, classes.padding20, classes.noBorderXS].join(' ')}>
              <div align="center">
                <img src={EmailSVG} alt="status" className={classes.profileStatusIcon} />
              </div>
              <Typography variant="headline" align="center" className={classes.regTitle}>
                Your Profile is complete &amp; unapproved
              </Typography>
              <Typography variant="body1" align="center">
                We have sent you a confirmation email with further instructions
              </Typography>
              <br /><hr /><br />
              {display}
            </Paper>
          </Grid>
        </Grid>
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.profile.loading,
    profile_id: state.profile.profile_id,
    site_settings: state.profile.site_settings,
    profile_state: state.profile.profile_state,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    getProfileStatus: token => dispatch(profileActions.getProfileStatus(token)),
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompleteProfile));



// WEBPACK FOOTER //
// ./src/profile/containers/ProfileStatus.js